/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'design-element-three': {
    width: 236,
    height: 110,
    viewBox: '0 0 236 110',
    data: '<path pid="0" d="M236 104.192c-21.951.24-40.996-6.993-57.044-22.089-10.872-10.224-22.307-19.719-36.044-25.95-11.783-5.352-23.972-7.995-36.972-5.468-1.011.2-2.89-1.11-3.503-2.204C90.19 26.666 72.023 12.076 48.407 4.354 32.476-.858 16.263-1.52 0 3.07v5.8c16.975-5.46 33.784-4.127 50.237 1.888 19.84 7.25 35.333 20.043 46.205 38.279.696 1.16 1.259 2.394 1.863 3.562-3.842 2.792-7.75 5.137-11.08 8.137C79.5 67.678 75.65 76.46 76.586 86.95c.522 5.841 3.073 10.755 8.977 12.801 5.945 2.055 11.145-.033 15.517-4.15 5.713-5.378 7.61-12.487 7.601-19.952-.008-6.28-1.018-12.552-1.689-19.96 4.637-.032 9.804-.513 14.872-.008 12.561 1.26 23.591 6.736 33.56 14.102 7.858 5.808 15.261 12.262 22.589 18.733 16.139 14.234 35.043 20.887 56.348 21.293.547.009 1.093.125 1.64.191v-5.808zM101.195 58.399c.712 3.414 1.656 6.454 1.921 9.545.72 8.36.679 16.678-5.523 23.38-2.633 2.851-5.978 4.649-9.995 3.29-4.28-1.45-5.448-5.12-5.688-9.205-.663-11.16 7.287-22.627 19.285-27.01z" _fill="#62E2AA"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/design-element-three.js